import Vue from 'vue';
import Component from 'vue-class-component';

export enum NotificationType {
  success = 'success',
  error = 'error',
  warn = 'warn'
}

@Component({})
export default class NotificationServiceWrapper extends Vue {
  showNotification(type: NotificationType, title: string, text: string): void {
    Vue.notify({
      group: 'main',
      type,
      title,
      text
    });
  }
}
